// Tabs.jsx
import React from "react";

function Tabs({ tabsData }) {
  return (
    <div>
      <nav>
        <div className="nav nav-tabs">
          {tabsData.map((tab, index) => (
            <button
              key={index}
              className={`nav-link ${index === 0 ? "active" : ""}`}
              data-bs-toggle="tab"
              data-bs-target={`#tab-${index}`}
            >
              {tab.title}
            </button>
          ))}
        </div>
      </nav>

      <div className="tab-content">
        {tabsData.map((tab, index) => (
          <div
            key={index}
            className={`tab-pane fade ${index === 0 ? "show active" : ""}`}
            id={`tab-${index}`}
          >
            <div className="row">
              {tab.items.map((item, i) => (
                <div className="col-md-4 col-sm-6" key={i}>
                  <div className="couriers-box">
                    <img src={item.img} className="img-fluid" />
                    <p>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Tabs;